if (!customElements.get('cart-shipping-date')) {
  customElements.define(
    'cart-shipping-date',
    class CartShippingDate extends HTMLElement {
      constructor() {
        super();
        
        this.asapRadio = this.querySelector('#shipping-asap');
        this.futureRadio = this.querySelector('#shipping-future');
        this.dateInput = this.querySelector('#shipping-date-input');
        this.datePicker = this.querySelector('.shipping-date__date-picker');
        
        // Set default date if Future Date is selected and no date is set
        this.setDefaultDate();

        // Initialize cart attributes based on current radio state
        this.initializeCartAttributes();
        
        // Attach event listeners
        if (this.asapRadio) {
          this.asapRadio.addEventListener('change', this.onRadioChange.bind(this));
        }
        if (this.futureRadio) {
          this.futureRadio.addEventListener('change', this.onRadioChange.bind(this));
        }
        if (this.dateInput) {
          this.dateInput.addEventListener('change', this.onDateChange.bind(this));
        }
      }

      initializeCartAttributes() {
        if (this.asapRadio && this.asapRadio.checked) {
          this.updateCartAttributes('ASAP', '');
        } else if (this.futureRadio && this.futureRadio.checked) {
          const date = this.dateInput ? this.dateInput.value : '';
          this.updateCartAttributes('Future Date', date);
        }
      }

      setDefaultDate() {
        if (!this.dateInput) return;
        
        // If no date is set and Future Date is selected, set to minimum date
        if (!this.dateInput.value && this.futureRadio && this.futureRadio.checked) {
          const minDate = this.dateInput.getAttribute('min');
          if (minDate) {
            this.dateInput.value = minDate;
          }
        }
      }

      onRadioChange(event) {
        const value = event.target.value;
        
        if (value === 'asap') {
          // Hide date picker
          if (this.datePicker) {
            this.datePicker.classList.add('hidden');
          }
          // Clear cart attributes
          this.updateCartAttributes('ASAP', '');
        } else if (value === 'future') {
          // Show date picker
          if (this.datePicker) {
            this.datePicker.classList.remove('hidden');
          }
          // If date input has a value, update cart
          if (this.dateInput && this.dateInput.value) {
            this.updateCartAttributes('Future Date', this.dateInput.value);
          } else {
            // Set to minimum date
            this.setDefaultDate();
            if (this.dateInput && this.dateInput.value) {
              this.updateCartAttributes('Future Date', this.dateInput.value);
            }
          }
        }
      }

      onDateChange(event) {
        const selectedDate = event.target.value;
        if (this.futureRadio && this.futureRadio.checked) {
          this.updateCartAttributes('Future Date', selectedDate);
        }
      }

      updateCartAttributes(mode, date) {
        const attributes = {
          'Requested Ship Mode': mode
        };
        
        // Only include ship date if mode is Future Date and date exists
        if (mode === 'Future Date' && date) {
          attributes['Requested Ship Date'] = date;
        } else {
          // Clear the date attribute when ASAP is selected
          attributes['Requested Ship Date'] = '';
        }

        const body = JSON.stringify({ attributes });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart attributes updated:', data.attributes);
        })
        .catch(error => {
          console.error('Error updating cart attributes:', error);
        });
      }
    }
  );
}
